import { useRef, useState, type FormEvent } from 'react';
import { IconPlus } from '../../ui/icons';
import { inputClass } from '../../ui/Field';

/** Pinned to the bottom, above the home indicator. Keeps focus after adding so you can type the next item. */
export function AddItemBar({ onAdd }: { onAdd: (text: string) => void }) {
  const [text, setText] = useState('');
  const [error, setError] = useState<string | null>(null);
  const inputRef = useRef<HTMLInputElement>(null);

  function onSubmit(e: FormEvent) {
    e.preventDefault();
    const t = text.trim();
    if (!t) return;
    if (t.length > 200) {
      setError('Keep items under 200 characters.');
      return;
    }
    setError(null);
    onAdd(t);
    setText('');
    inputRef.current?.focus();
  }

  return (
    <div className="fixed inset-x-0 bottom-0 z-20 border-t border-line/70 bg-bg/90 pb-[calc(var(--safe-bottom)+0.75rem)] backdrop-blur-md">
      <form onSubmit={onSubmit} className="mx-auto flex max-w-xl items-start gap-2 px-4 pt-3" noValidate>
        <div className="min-w-0 flex-1">
          <label htmlFor="add-item" className="sr-only">
            Add an item
          </label>
          <input
            ref={inputRef}
            id="add-item"
            name="item"
            placeholder="Add an item…"
            autoComplete="off"
            autoCapitalize="sentences"
            enterKeyHint="send"
            maxLength={200}
            value={text}
            onChange={(e) => setText(e.target.value)}
            aria-invalid={error ? true : undefined}
            aria-describedby={error ? 'add-item-err' : undefined}
            className={inputClass}
          />
          {error && (
            <p id="add-item-err" className="mt-1 text-sm text-danger">
              {error}
            </p>
          )}
        </div>
        <button
          type="submit"
          aria-label="Add item"
          disabled={!text.trim()}
          className="grid size-12 shrink-0 place-items-center rounded-xl bg-accent text-on-accent shadow-sm transition-[opacity,transform] active:scale-95 disabled:opacity-40"
        >
          <IconPlus />
        </button>
      </form>
    </div>
  );
}
